import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Dropdown from "react-bootstrap/Dropdown";
import Row from "react-bootstrap/Row";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import * as queries from "../../graphql/queries";
import { Table } from "../Table/Table";
import {
  PushNotificationType,
  Schedule,
  TableData,
  getPushNotificationType,
  scheduleStatus,
} from "../_shared/pushNotifications/types";
import { sortTableDataByDateTime } from "../_shared/utils";
import "./PushNotification.css";
import { createTableRowItem } from "./helper";

export const PushNotification = () => {
  const [pushNotifcationSchedules, setPushNotificationSchedules] = useState<
    Schedule[]
  >([]);
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [statusFilteredTableData, setStatusFilteredTableData] = useState<
    TableData[]
  >([]);
  const [filteredTableData, setFilteredTableData] = useState<any>([]);
  const [search, setSearch] = useState<string>("");
  const [isLoaded, setIsLoaded] = useState(false);

  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent<HTMLInputElement>) => {
    let filter: string = (e.target as HTMLInputElement).value;
    let dataToFilter: TableData[] = [];
    if (statusFilteredTableData.length > 0) {
      dataToFilter = statusFilteredTableData;
    } else {
      dataToFilter = tableData;
    }
    const filteredData = dataToFilter.filter((item) => {
      return (
        item.Name.toLowerCase().includes(filter.toLowerCase()) ||
        item.Title.toLowerCase().includes(filter.toLowerCase()) ||
        item.Body.toLowerCase().includes(filter.toLowerCase())
      );
    });
    setSearch((e.target as HTMLInputElement).value);
    setFilteredTableData(filteredData);
  };

  const handleStatusFilter = (value: scheduleStatus) => {
    const filteredData = tableData.filter((item) => {
      return item.Status === value;
    });
    setStatusFilteredTableData(filteredData);
    setFilteredTableData(filteredData);
  };

  const fetchPushNotifications = async () => {
    const response = (await API.graphql(
      graphqlOperation(queries.getPushNotification)
    )) as GraphQLResult<getPushNotificationType>;

    console.log("fetchPushNotifications response: ", response);

    if (response.errors) {
      console.log("fetchPushnotification error: ", response.errors);
      throw new Error(
        "Sorry, something went wrong with fetching push notifications"
      );
    }

    // Push notification schedules returned by CDP
    const schedules: Schedule[] =
      response.data.getPushNotification.allSchedules.schedules;

    // Push notification stored in DynamoDB
    const pushNotifcation: PushNotificationType[] =
      response.data.getPushNotification.pushNotification;

    console.log("fetchPushNotifications dynamodb: ", pushNotifcation);
    console.log("fetchPushNotifications schedules: ", schedules);

    const getPushNotificationDbData = (
      scheduleId: number
    ): PushNotificationType =>
      pushNotifcation.find((i) => i.scheduleId === scheduleId);

    const createLists = schedules.reduce(
      (
        acc: { tableList: TableData[]; scheduleList: Schedule[] },
        schedule: Schedule
      ) => {
        const scheduleDb: PushNotificationType = getPushNotificationDbData(
          schedule.scheduleId
        );

        if (scheduleDb !== undefined) {
          acc.tableList.push(createTableRowItem(scheduleDb, schedule));
          acc.scheduleList.push(schedule);
        }
        return acc;
      },
      {
        tableList: [],
        scheduleList: [],
      }
    );

    const filteredData = sortTableDataByDateTime(createLists.tableList);
    console.log("filteredData: ", filteredData);
    setPushNotificationSchedules(createLists.scheduleList);
    setFilteredTableData(filteredData);
    setTableData(filteredData);
    setIsLoaded(true);
  };

  const selectPushNotification = (row) => {
    const data = pushNotifcationSchedules.find((item) => {
      return row.ScheduleId === item.scheduleId;
    });

    navigate(`/push-notification/${row.id}`, {
      state: {
        success: data.numSuccess,
        failure: data.numFailure,
        optedOut: data.numOptedOut,
        status: data.status,
      },
    });
  };

  useEffect(() => {
    fetchPushNotifications();
  }, []);

  const statuses: scheduleStatus[] = [
    "COMPLETED",
    "SCHEDULED",
    "STOP",
    "PAUSE",
  ];

  const dropdownItems = statuses.map((status) => (
    <Dropdown.Item
      key={status}
      as="button"
      onClick={() => {
        handleStatusFilter(status);
      }}
    >
      {status}
    </Dropdown.Item>
  ));

  return (
    <div className="page-container">
      <div className="title">Push Notifications</div>
      <Container fluid>
        <Row className="searchContainer">
          <Col xs={4}>
            <input
              value={search}
              onChange={handleSearch}
              className="searchBar"
            />
          </Col>
          <Col className="buttonContainer" xs={4}>
            <Dropdown className="dropDown">
              <Dropdown.Toggle variant="danger" id="status-dropdown">
                Status
              </Dropdown.Toggle>
              <Dropdown.Menu>{dropdownItems}</Dropdown.Menu>
            </Dropdown>
            <Button
              variant="secondary"
              className="searchBtn"
              onClick={() => {
                setSearch("");
                setFilteredTableData(tableData);
                setStatusFilteredTableData([]);
              }}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </Container>
      {isLoaded && (
        <div style={{ display: "flex", flex: 1 }}>
          {filteredTableData.length > 0 ? (
            <Table
              tableRows={filteredTableData}
              excludeKeys={["id"]}
              pagination={10}
              handleSelect={selectPushNotification}
            />
          ) : (
            <Container fluid>
              <Row>
                <Col xs={4} />
                <Col xs={4}>
                  No search results could be found for the values you entered.
                </Col>
                <Col xs={2} />
              </Row>
            </Container>
          )}
        </div>
      )}
    </div>
  );
};
